import * as React from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import {useDispatch} from 'react-redux';

import routeByName from '~/constants/routes';
import {navigateAction} from '~/actions/navigateActions';
import useModalById from '~/customHooks/useModalById';
import {MODAL_ALLOW_TEXT_MESSAGES} from '~/rootStore/modals/modalsIds';

import ModalBase from '../ModalBase';
import {ReactComponent as ChatDisabledIcon} from './img/chat-disabled-icon.svg';
import ModalBaseContent from '../ModalBaseContent';

const ModalAllowTextMessages: React.FC = () => {
  const {isOpen, close: onClose} = useModalById(MODAL_ALLOW_TEXT_MESSAGES);

  const dispatch = useDispatch();
  const actionBtnHandler = () => {
    dispatch(navigateAction(routeByName.textSettings));
    onClose();
  };

  return (
    <ModalBase
      open={isOpen}
      onClose={onClose}
      showOkButton={false}
      buttons={[
        <Button key="cancel" variant="text" color="default" onClick={() => onClose()}>
          <Box fontWeight="normal">Cancel</Box>
        </Button>,
        <Button key="text-settings" variant="text" color="primary" onClick={actionBtnHandler}>
          <Box fontWeight="normal">Text Settings</Box>
        </Button>,
      ]}
    >
      <ModalBaseContent
        image={<ChatDisabledIcon />}
        title="Chat is Disabled"
        description={
          <>
            In order to be able to chat again please enable <b>Allow Text Messages</b> in the{' '}
            <b>Text Settings</b>
          </>
        }
      />
    </ModalBase>
  );
};

export default ModalAllowTextMessages;
